<template>
  <div class="pageDiv">
    <v-card class="main-card" v-if="!$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0">
        <span class="page-title">Registration List</span>
      </v-card-title>
      Must login to view data
    </v-card>

    <v-card class="main-card" v-if="$AuthSvc.isLogin()">
      <v-card-title style="padding-bottom:0"  v-if="tournament !== null">
        <span class="course-name">{{course!==null?course.name:''}} ({{members.length}} players)</span>
      </v-card-title>

      <v-card-text v-if="tournament === null">
        No tournaments to register at this time.
      </v-card-text>

      <v-card-text class="member-table-card" v-if="registerTournaments !== null && registerTournaments.length > 1">
        <v-card-title>
          Select course for registration list:
        </v-card-title>
        <v-card-text class="member-table-card">
          <div  v-for="tn in registerTournaments" :key="tn.tournament.tournamentId" style="padding:5px 10px; width:100%;text-align:left;">
            <div class="select-btn" @click="selectTournament(tn)">
              <span style="display:inline-block;padding-top:7px;;text-align:left;margin-right:20px">
                {{printDateTime(tn.tournament.scheduleDate)}}
              </span>
              <span style="display:inline-block;padding-top:7px;text-align:left;">
                {{tn.course!==null?tn.course.name:''}}
              </span>
              <span> ({{tn.tournament.formatType}}) </span>
            </div>
          </div>
        </v-card-text>
      </v-card-text>

      <v-card-text v-if="tournament !== null">
        <input type="checkbox" style="width:20px;height:20px" v-model="showBirdie" @change="filterPlayers()"> Birdie Hunts
        <input type="checkbox" style="width:20px;height:20px" v-model="showNick" @change="filterPlayers()"> Nicklaus
        <input type="checkbox" style="width:20px;height:20px" v-model="showPalm" @change="filterPlayers()"> Palmer
        <input type="checkbox" style="width:20px;height:20px" v-model="showHogan" @change="filterPlayers()"> Hogan
                <input type="checkbox" style="width:20px;height:20px" v-model="showOwe" @change="filterPlayers()"> Owe
      </v-card-text>

      <v-card-text v-if="tournament !== null">
        <a v-bind:href="'/api/tournaments/' + tournament.tournamentId + '/registrations-csv'">
          Tournament Group CSV file
        </a>
      </v-card-text>

      <v-card-text class="member-table-card" v-if="members.length>0">
        <v-simple-table class="simple-table">
          <tr>
            <th width="10px">#</th>
            <th width="10px">ID</th>
            <th width="10px"></th>
            <th style="width: 220px !important">Player Name</th>
            <th>Cell_Phone</th>
            <th width="10px">Birdie</th>
            <th width="40px">Flight</th>
            <th width="10px">HCP</th>
            <th width="200px">Special_Request</th>
            <th width="10px">Fee</th>
            <th width="10px">Late</th>
            <th width="10px">HIO</th>
            <th width="10px">Member</th>
            <th width="10px">PayType</th>
            <th width="10px">Owe</th>
          </tr>
          <tr v-for="(n, index) in members" :key="n.userid">
            <td>{{index+1}}</td>
            <td>{{n.playerId}}</td>
            <td><v-icon @click="removeRegistration(n)">mdi-delete</v-icon></td>
            <td>{{n.firstName}} {{n.middleName}} {{n.lastName}}</td>
            <td>{{formatPhoneNumber(n.cellPhone)}}</td>
            <td>
              <v-btn style="font-size:12px;height:26px;width:20px;" 
                     :class="{yesHunt: n.birdieHunt==='Yes', noHunt: n.birdieHunt==='No'}" 
                     @click="toggleBirdieHunt(n)">{{n.birdieHunt}}</v-btn>
            </td>
            <td>
              <select class="dropdown" v-model="n.flight">
                <option value="Nicklaus">Nicklaus</option>
                <option value="Palmer">Palmer</option>
                <option value="Hogan">Hogan</option>
                <option value="Women">Women</option>
              </select>
            </td>
            <td><input style="width:40px" type="text" v-model="n.handicap"></td>
            <td><input style="width:300px" type="text" v-model="n.specialRequest"></td>
            <td><input type="text" v-model="n.fee"></td>
            <td><input type="text" v-model="n.lateFee"></td>
            <td><input type="text" v-model="n.holeInOne"></td>
            <td><input type="text" v-model="n.memberFee"></td>
            <td>
              <select class="dropdown" v-model="n.paymentType" style="width:80px">
                <option value="PayPal">PayPal</option>
                <option value="Zelle">Zelle</option>
                <option value="Venmo">Venmo</option>
                <option value="Complimentary">Complimentary</option>
                <option value="StandBy">StandBy</option>
              </select>
            </td>
            <td><input width="10px" type="text" v-model="n.owe"></td>
          </tr>
        </v-simple-table>
      </v-card-text>

      <v-card-actions class="actions-card" v-if="tournament!==null">
        <v-btn style="background-color:black;color:white;" @click="formSubmit()">Save</v-btn>
      </v-card-actions>

    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import swal from 'sweetalert';

  export default {
    name: "login",
    data: () => ({
      selectCourse: null,
      tournament: null,
      course: null,
      registerTournaments: [],
      membersData: [],
      members: [],
      data: [],
      showBirdie: false,
      showNick: true,
      showPalm: true,
      showHogan: true,
      showWomen: true,
      showOwe: false
    }),
    mounted: function() {
      var _this = this;

      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get('id')
      if (id !== null && id !== '') {
        _this.$CommandSvc.get(_this, '/public/tournaments/' + id, function(data) {
          if (data.length !== null) {
            _this.tournament = data;
            _this.loadPlayerList(_this.tournament, false);
          }
        });
      } else {
        _this.$CommandSvc.get(_this, '/public/tournaments/status/APPROVALS', function(data) {
          _this.registerTournaments = data;
          if (data.length === 1) {
            _this.course = data[0].course;
            _this.tournament = data[0].tournament;
            _this.loadPlayerList(_this.tournament, false);
          }
        });
      }
    },
    methods: {
      filterPlayers() {
        var _this = this;
        var data = _this.membersData;

        _this.members = new Array();
        for(var i=0; i < data.length; i++) {
          if (_this.showBirdie) {
            if (_this.showNick && data[i].flight === 'Nicklaus' && data[i].birdieHunt === 'Yes') {
              _this.members.push(data[i]);
            }
            if (_this.showPalm && data[i].flight === 'Palmer' && data[i].birdieHunt === 'Yes') {
              _this.members.push(data[i]);
            }
            if (_this.showHogan && data[i].flight === 'Hogan' && data[i].birdieHunt === 'Yes') {
              _this.members.push(data[i]);
            }
            if (_this.showWomen && data[i].flight === 'Women' && data[i].birdieHunt === 'Yes') {
              _this.members.push(data[i]);
            }
          }
          else if (_this.showOwe) {
            if (_this.showNick && data[i].flight === 'Nicklaus' && data[i].owe > 0) {
              _this.members.push(data[i]);
            }
            if (_this.showPalm && data[i].flight === 'Palmer' && data[i].owe > 0) {
              _this.members.push(data[i]);
            }
            if (_this.showHogan && data[i].flight === 'Hogan' && data[i].owe > 0) {
              _this.members.push(data[i]);
            }
            if (_this.showWomen && data[i].flight === 'Women' && data[i].owe > 0) {
              _this.members.push(data[i]);
            }
          }
          else {
            if (_this.showNick && data[i].flight === 'Nicklaus') {
              _this.members.push(data[i]);
            }
            if (_this.showPalm && data[i].flight === 'Palmer') {
              _this.members.push(data[i]);
            }
            if (_this.showHogan && data[i].flight === 'Hogan') {
              _this.members.push(data[i]);
            }
            if (_this.showWomen && data[i].flight === 'Women') {
              _this.members.push(data[i]);
            }
          }
        }
      },
      getName(n) {
        return n.firstName + " " + n.middleName + " " + n.lastName;
      },
      hasRegistered() {
        return this.nicklaus.length > 0 ||
               this.palmer.length > 0 ||
               this.hogan.length > 0 ||
               this.nonMember.length > 0 ||
               this.women.length > 0;
      },
      printDateTime(date) {
        return moment(date).format('MM/DD hh:mm A');
      },
      selectTournament(tn) {
        this.course=tn.course;
        this.tournament = tn.tournament;
        window.location.href = "/approval-admin?id=" + tn.tournament.tournamentId;
      },
      loadPlayerList(tournament) {
        var _this = this;

        if (_this.course === null) {
          _this.$CommandSvc.get(_this, '/public/courses/' + tournament.courseId, function(data) {
            _this.course = data;
          });
        }

        _this.$CommandSvc.get(_this, '/api/tournaments/' + tournament.tournamentId + '/registrations-admin', function(data) {
          _this.membersData = data;
          _this.filterPlayers();
        });
      },
      removeRegistration(n) {
        var _this = this;

        console.log('REMOVE REGISTRATION ' + n.scoreCardId);
          swal({
            title: "Are you sure?",
            text: "Delete " + this.getName(n) + "? You cannot recover!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {
                _this.axios.delete('/api/scores/' + n.scoreCardId)
                .then(function (response) {
                    _this.loadPlayerList(_this.tournament, false);
                })
                .catch(function (error) {
                    swal("Error", "Cannot remove registration because it has references.", "error");
                    console.log('ERROR: ' + error);
                });
            }
          });
      },
      toggleJackpot(scoreCard) {
        var _this = this;

        if (scoreCard.jackpot === 'Yes') {
          scoreCard.jackpot = 'No';
        }
        else {
          scoreCard.jackpot = 'Yes';
        }

        _this.axios.post('/api/scores/save-jackpot', scoreCard)
        .then(function () {
            _this.loadPlayerList(_this.tournament, false);
        })
        .catch(function (error) {
           console.log('ERROR: ' + error);
        });
      },
      toggleBirdieHunt(scoreCard) {
        var _this = this;

        if (scoreCard.birdieHunt === 'Yes') {
          scoreCard.birdieHunt = 'No';
        }
        else {
          scoreCard.birdieHunt = 'Yes';
        }

        _this.axios.post('/api/scores/save-birdie', scoreCard)
        .then(function () {
            _this.loadPlayerList(_this.tournament, false);
        })
        .catch(function (error) {
           console.log('ERROR: ' + error);
        });
      },
      formSubmit() {
          this.axios.post('/api/scores/score-all-cards', this.members)
          .then(function (response) {
             swal("Success", "Saved Successfully.", "info");
          })
          .catch(function (error) {
              swal("Error", "Save Failed.", "error");
              console.log('ERROR: ' + error);
          });
      },
      formatPhoneNumber(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          return match[1] + '-' + match[2] + '-' + match[3];
        }
        return null;
      }
    }
  }

</script>

<style scoped>
  input {
    border: 1px solid black;
    border-radius: 5px;
    margin: 3px;
    padding: 3px 5px;
    width: 45px;
  }

  .table.b-table>thead>tr>th {
    background-color: white;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    z-index: 2;
  }

  .dollar {
    font-family: Copperplate !important;
  }

  @media (min-width: 768px) {

  }

  th, td {
    font-size: 12px !important;
  }

  .member-table-card {
      overflow-y: scroll;
      height: 100%;
  }

  .course-name {
    display: inline-block;
    width: 100%s;
    margin-top: 20px;
  }

  .select-btn {
    margin-right: 20px;
    text-align: left;
    background-color: #1867c0;
    width:100%;
    border-radius: 7px;
    padding: 10px;
    color: white;
  }

  .select-btn:hover {
    cursor: pointer;
  }

  .noHunt {
    background-color: lightgrey !important;
    color: black;
  }

  .yesHunt {
    background-color: rgb(24 103 192) !important;
    color: white;
  }

  .stillOwe {
    background-color: red
  }

</style>